import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import styled from '@emotion/styled';

// this component will accept either a to or an href
// it will also style the button as a link

interface LinkButtonProps {
  children: React.ReactNode;
  to?: string;
  onClick?: () => void;
  [key: string]: any;
}

const LinkButton = ({ children, to, onClick, ...props }: LinkButtonProps) => {
  const history = useHistory();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
    if (to) history.push(to);
  };

  return (
    <NavLinkButton variant="text" onClick={handleOnClick} disableRipple {...props}>
      {children}
    </NavLinkButton>
  );
};

export default LinkButton;

const NavLinkButton = styled(Button)`
  && {
    padding: 0;
    min-width: auto;
    min-height: auto;
    margin: 0;
    letter-spacing: 0;
    line-height: 1;
    text-transform: none;
    &:hover {
      background: transparent;
    }
  }
`;
